import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthConfig } from './auth/auth-config';

@Injectable()
export class ConfigService {

    private values: Configs = new Configs();
    constructor() { }

    load = async <T>(env: T): Promise<T> => {
        try {
                const response = fetch('./assets/configs.json');
                const configs: T = await (await response).json();
                for (const key in configs) {
                if (Object.prototype.hasOwnProperty.call(configs, key)) {
                    const targetProp = env[key];
                    if (targetProp !== undefined) {
                        env[key] = configs[key];

                        switch(key) {
                            case 'apiBaseUrl':
                                this.values.apiBaseUrl = configs[key];
                                break;
                            case 'defaultOrgCode':
                                this.values.defaultOrgCode = configs[key];
                                break;
                            case 'logosBaseUrl':
                                this.values.logosBaseUrl = configs[key];
                                break;
                            case 'production':
                                this.values.production = configs[key];
                                break;
                            case 'socialLogosBaseUrl':
                                this.values.socialLogosBaseUrl = configs[key];
                                break;
                            case 'taglineUrl':
                                this.values.taglineUrl = configs[key];
                                break;
                            case 'anniversaryUrl':
                                this.values.anniversaryUrl = configs[key];
                                break;
                            case 'floridaTrendUrl':
                                this.values.floridaTrendUrl = configs[key];
                                break;
                            case 'joinourteamUrl':
                                this.values.joinourteamUrl = configs[key];
                                break;
                            case 'msrealestateUrl':
                                this.values.msrealestateUrl = configs[key];
                                break;
                            case 'oraSealUrl':
                                this.values.oraSealUrl = configs[key];
                                break;
                            case 'bestPlacesToWorkUrl':
                                this.values.bestPlacesToWorkUrl = configs[key];
                                break;
                            case 'msalConfig':
                                this.values.msalConfig = configs[key];
                                break;

                        }
                    }
                }
            }
        }
        catch (e) {}
        return env;
    };

    // Gets a value of specified property in the configuration file
    get(key: any) {
        switch(key) {
            case 'apiBaseUrl':
                return this.values.apiBaseUrl;
                break;
            case 'defaultOrgCode':
                return this.values.defaultOrgCode;
                break;
            case 'logosBaseUrl':
                return this.values.logosBaseUrl;
                break;
            case 'production':
                return this.values.production;
                break;
            case 'socialLogosBaseUrl':
                return this.values.socialLogosBaseUrl;
                break;
            case 'taglineUrl':
                return this.values.taglineUrl;
                break;
            case 'anniversaryUrl':
                return this.values.anniversaryUrl;
                break;
            case 'floridaTrendUrl':
                return this.values.floridaTrendUrl;
                break;
            case 'msrealestateUrl':
                return this.values.msrealestateUrl;
                break;
            case 'joinourteamUrl':
                return this.values.joinourteamUrl;
                break;
            case 'oraSealUrl':
                return this.values.oraSealUrl;
                break;
            case 'bestPlacesToWorkUrl':
                return this.values.bestPlacesToWorkUrl;
                break;

        }
    }

    getAuthConfig(): AuthConfig {

        const authConfig = { 
            clientId: 'b9fd5c37-74fe-40d7-ab98-01cf2eed9dc5', //da19986d-4136-455c-b2a5-47f437efe3c3
            logLevel: 1,
            protectedResourceMap: new Map([
              [
                this.values.apiBaseUrl + '/*',
                ['48b0d4a9-ac50-44f1-910b-c22a80624031/user_impersonation']
              ]
            ])
          } as AuthConfig;

        return authConfig;
    }
}

export function configFactory(config: ConfigService) {
    return () => config.load(environment);
}

export class Configs {
    apiBaseUrl: any;
    defaultOrgCode: any;
    logosBaseUrl: any;
    production: any;
    socialLogosBaseUrl: any;
    taglineUrl: any;
    anniversaryUrl: any;
    floridaTrendUrl: any;
    joinourteamUrl: any;
    msrealestateUrl: any;
    oraSealUrl: any;
    bestPlacesToWorkUrl: any;
    apiConfig: any;
    msalConfig: any;
}
